import React from "react";

import { View, ActivityIndicator, StyleProp, ViewStyle } from "react-native";
import { useTheme } from "react-native-paper";

const Loader = ({
  color,
  style,
}: {
  color?: string;
  style?: StyleProp<ViewStyle>;
}) => {
  const { colors } = useTheme();
  return (
    <View
      style={[
        { flex: 1, justifyContent: "center", alignItems: "center" },
        style,
      ]}
    >
      <ActivityIndicator size="large" color={color ?? colors.primary} />
    </View>
  );
};

export default Loader;
